module.exports = __webpack_public_path__ + "img/IDR.c94b5c01.svg";